import axios from 'axios';

//Dev
//const API_BASE_URL = 'http://127.0.0.1:8080';

//Prod
const API_BASE_URL = 'https://reservations-api.greenriver-paris.fr';

class AuthService {
    async login(credentials) {
        return await axios.post(API_BASE_URL + "/login", credentials);
    }

    getToken() {
        return localStorage.getItem("token");
    }

    getUrl(url) {
        return API_BASE_URL + url;
    }

    getAuthHeader(locale) {
        locale = !!locale ? locale : "fr";
        return { headers: { Authorization: 'Bearer ' + this.getToken(),"Accept-Language": locale} };
    }

    getAuthHeaderUpload(locale, progress) {
        locale = !!locale ? locale : "fr";
        return { headers: { Authorization: 'Bearer ' + this.getToken(),"Accept-Language": locale}, progress };
    }
}

export default new AuthService();
